import { PropsWithChildren } from 'react';
import { Advisories } from '../components/advisories/advisories';
import { GlobalAdvisoriesApi } from '../hooks/use-advisories';
import { Outlet } from 'react-router';

export interface BasePageProps {
    advisoriesApi: GlobalAdvisoriesApi;
}

export interface BaseLayoutProps {
    advidoriesContainerRef: React.RefObject<HTMLDivElement>;
    advisoriesApi: GlobalAdvisoriesApi;
}

export function BaseLayout(props: PropsWithChildren<BaseLayoutProps>) {
    return (
        <>
            <Advisories containerRef={props.advidoriesContainerRef} advisories={props.advisoriesApi.advisories} onClose={props.advisoriesApi.remove} />
            <Outlet />
            {props.children}
        </>
    );
}